var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-text-editor',{attrs:{"value":_vm.value},on:{"input":_vm.onInput,"blur":function($event){return _vm.$emit('save')}}})}
var staticRenderFns = []

export { render, staticRenderFns }